import FormContainer from 'components/FormContainer';
import AuctionAccessLookup from './Lookup';
import AuctionAccessProgress from './shared/AuctionAccessProgress';
import AuctionAccessDocuments from './Documents';
import AuctionAccessPaymentMethods from './PaymentMethods';
import { AuctionAccessLookupLoading } from './shared/AuctionAccessLookupLoading';
import { AUCTION_ACCESS_SIGNUP_STAGE } from './useAuctionAccessSignup';

export const AuctionAccessSignupTopContent = ({ isOnboardingFlow, stage }) => {
	if (!isOnboardingFlow) return null;

	return (
		<>
			{stage === AUCTION_ACCESS_SIGNUP_STAGE.REVIEW && <AuctionAccessProgress activeStep={1} />}
			{stage === AUCTION_ACCESS_SIGNUP_STAGE.DOCUMENTS && <AuctionAccessProgress activeStep={2} />}
			{stage === AUCTION_ACCESS_SIGNUP_STAGE.PAYMENT_METHODS && <AuctionAccessProgress activeStep={3} />}
		</>
	);
};

export const AuctionAccessSignupContent = ({ anonymousId, controller, signInUrl, signUpPolicies, state }) => {
	if (!controller || controller.shouldRenderStandardSignup) return null;

	if (controller.isDocumentsSubmitting) {
		return (
			<FormContainer>
				<AuctionAccessLookupLoading />
			</FormContainer>
		);
	}

	if (controller.isPaymentMethods) {
		return (
			<FormContainer>
				<AuctionAccessPaymentMethods
					error={controller.error}
					isSubmitting={controller.isSubmitting}
					onBack={controller.returnFromPaymentMethods}
					onContinue={controller.submitAuctionAccessPaymentMethods}
					onRetry={controller.refreshAuctionAccessPaymentMethods}
					onSelectionChange={controller.updatePaymentMethodSelection}
					paymentMethods={controller.paymentMethods}
				/>
			</FormContainer>
		);
	}

	if (controller.isDocuments) {
		return (
			<FormContainer>
				<AuctionAccessDocuments
					dealershipType={controller.dealershipType}
					error={controller.error}
					initialValues={state?.values?.[2] || {}}
					isBackDisabled={controller.isResumedAuctionAccessSignup}
					onBack={controller.returnToAuctionAccessLookup}
					onComplete={controller.submitAuctionAccessDocuments}
				/>
			</FormContainer>
		);
	}

	if (controller.isLookupOpen) {
		return (
			<FormContainer>
				<AuctionAccessLookup
					anonymousId={anonymousId}
					initialAccount={controller.auctionAccessVerifiedAccount}
					initialValues={state?.values?.[2] || {}}
					error={controller.error}
					isReviewSubmitting={controller.isReviewSubmitting}
					onContinueManually={controller.continueWithoutAuctionAccess}
					onLookupSuccess={controller.hydrateAuctionAccessSignup}
					onLookupStateChange={controller.handleLookupStateChange}
					onReviewNext={controller.handleReviewNext}
					signInUrl={signInUrl}
					signUpPolicies={signUpPolicies}
				/>
			</FormContainer>
		);
	}

	return null;
};

export {
	default as useAuctionAccessSignup,
	AUCTION_ACCESS_SIGNUP_STAGE,
	isVerifiedAuctionAccessSignup,
} from './useAuctionAccessSignup';
